class ChannelInfo {
    constructor(_data) {
        this.setChannelTemplate(_data)
    }

    setChannelTemplate(_data){
        const html = `<img src="${_data.thumb}" class="official-info-logo">
			<h2 class="official-info-title">${_data.title}</h2>
			<p class="official-info-desc">${_data.description}</p>`

        $('.official-info').html( html );
    }
} // end of class
export default ChannelInfo;
